import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBUjHxGiXX9H3TJ2Kxdak2JQr8VyR7OOVM",
  authDomain: "pixabay-e0035.firebaseapp.com",
  projectId: "pixabay-e0035",
  storageBucket: "pixabay-e0035.appspot.com",
  messagingSenderId: "20073160723",
  appId: "1:20073160723:web:9a99e191c2c17c42a31fe6",
  measurementId: "G-PB46NWX84B"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, app };